<div class="soctrip-dropdown">
  <button class="text-input w-full min-w-[204px] flex items-center justify-between gap-1 border border-palette-gray-300 rounded-lg !px-4 py-2 h-[38px] hover:border-palette-blue-300"
    (click)="toggleListItems()" [ngClass]="{'bg-palette-gray-100': isShowListItems}">
    <div class="relative">
      <p class="line-clamp-1 text-palette-gray-700 text-sm font-normal leading-5">
        <ng-container *ngIf="selectedItems.length > 0; else placehoderTemplate">
          <ng-container *ngIf="(selectedItems.length == listItems.length) && showAllItemPlaceHoder; else selectItems">
            <span class="text-sm font-medium text-palette-gray-900">
              {{ allItemLabel || 'COMMON.ALL_ITEM' | translate }}
            </span>
          </ng-container>
          <ng-template #selectItems>
            <span class="text-sm font-medium text-palette-gray-900">
              {{ 'COMMON.ITEMS_SELECTED' | translate : { count: this.selectedItems.length, suffix: selectedItems.length > 1 ? 's' : ''} }}
            </span> 
          </ng-template>           
        </ng-container>
        <ng-template #placehoderTemplate>
          <span class="text-sm font-normal text-palette-gray-400">
            {{ placehoder || 'COMMON.SELECT_ITEM' | translate }}
          </span>
        </ng-template>
      </p>
    </div>
    <i class="sctr-icon-chevron-down !text-[20px] text-palette-gray-500 font-normal cursor-pointer"></i>
  </button>
  <p-overlay [(visible)]="isShowListItems" (onHide)="onClosePopup()">
    <ng-template pTemplate="content">
      <div class="bg-white w-auto custom-height max-h-[400px] rounded-lg border border-palette-gray-200 !mt-2 overflow-scroll">
        <!-- Search -->
        <ng-container *ngIf="allowSearch;">
          <div class="search flex items-center justify-between m-0 border-b border-b-palette-gray-200 !pl-1 !pt-1 !pr-2">
            <span class="p-input-icon-left w-auto h-11">
              <i class="pi pi-search !top-[45%]"></i>
              <input type="text" class="w-auto h-10 text-sm" 
                pInputText 
                [(ngModel)]="searchKey" 
                (ngModelChange)="onSearchInputChange()"
                [placeholder]="placehoderSearch || 'COMMON.SEARCH_BY_NAME' | translate"/>
            </span>
            <i class="!w-4 !h-4 sctr-icon-x-close !mb-1 !mr-2 cursor-pointer" (click)="clearSearchKey()"></i>
          </div>
        </ng-container>
        <!-- List item -->
        <div class="m-0 !px-4 !py-2 gap-1 h-auto max-h-[calc(100%-50px)] overflow-y-scroll">
          <!-- List items empty -->
          <div *ngIf="filteredItems.length == 0" class="flex flex-col items-center justify-center !gap-4 !py-[50px]">
            <div class="flex justify-center items-center !w-10 h-10 !p-4 rounded-full !border-4 bg-palette-gray-200 border-palette-gray-100">
              <i class="{{notFoundIcon}} font-inter flex justify-center items-center text-sm font-medium !leading-4 text-palette-gray-900 !w-4 !h-4 bg-palette-gray-200 rounded-full"></i>
            </div>
            <p class="font-inter text-sm font-medium !leading-4 text-palette-gray-900">
              {{ notFoundLabel  || 'No item' | translate}}
            </p>
          </div>
          <!-- List have items -->
          <div *ngIf="filteredItems.length > 0" class="gap-1">
            <!-- Checkbox tick ALL -->
            <ng-container *ngIf="allowTickAll;">
              <div (click)="changeSelectedAllItems()" class="field-checkbox flex gap-1 h-11 !m-0 cursor-pointer">
                <ng-container *ngIf="selectedItems.length > 0; else noItem">
                  <div class="flex items-center justify-center bg-palette-blue-600 !w-[22px] aspect-square !p-0.5 rounded-[6px]">
                    <ng-container *ngIf="selectedItems.length == filteredItems.length; else notYet">
                      <i class="p-checkbox-icon pi pi-check text-white font-semibold text-xs"></i>
                    </ng-container>
                    <ng-template #notYet>
                      <i class="sctr-icon-minus text-white font-semibold text-xs"></i>
                    </ng-template>
                  </div>
                </ng-container>
                <ng-template #noItem>
                  <div class="border-[2px] border-palette-gray-300 !w-[22px] aspect-square !p-0.5 rounded-[6px]"></div>
                </ng-template>
                <label [for]="'ALL'"
                  class="rounded-full px-[6px] py-[2px] font-inter text-sm font-medium !leading-4 text-palette-gray-900 cursor-pointer">
                  {{ allItemLabel || 'COMMON.ALL' | translate}}
                </label>
              </div>
            </ng-container>
            <!-- List checkox item -->
            <div *ngFor="let item of filteredItems" class="field-checkbox flex h-11 !m-0">
              <p-checkbox 
                name="group" 
                [value]="item" 
                [(ngModel)]="selectedItems"
                (ngModelChange)="selectItem()"
                [inputId]="item.value"></p-checkbox>
              <label [for]="item.value"
                class="rounded-full px-[6px] py-[2px] font-inter text-sm font-medium !leading-4 text-palette-gray-900 cursor-pointer">
                {{ item.label | translate }}
              </label>
            </div>                          
          </div>          
        </div>
      </div>
    </ng-template>
  </p-overlay>
</div>